export const PRIMARY_COLOR = "#001489";
export const MONTH_LIST = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const TABLE_PAGINATION_COUNT = [10, 20, 50, 100];
export const INTERCHANGE_HEAD_STYLE = { border: "solid 1px #525252" };
export const ALIGN_ITEMS = { alignItems: "center" };
export const MARGIN_TB_ITEMS = {
  marginTop: "10px",
  marginBottom: "10px",
};
export const TXT_CENTER = { textAlign: "center" };
export const POINTER = { cursor: "pointer" };
export const FLEX_END_ITEMS = { display: "flex", justifyContent: "flex-end" };
export const MARGIN_B = {
  marginBottom: "10px",
};
export const MAXIMUM_VEHICLE_HEIGHT = { maxHeight: "420px" };
export const VIN_DECODER_VIEW = {
  height: "245px",
  overflowY: "auto",
  overflowX: "hidden",
};
export const VIN_DECODE_FILTER_VIEW = { height: "150px" };
export const FILTER_SECTION_STYLE = {
  padding: "20px",
  backgroundColor: "rgb(229, 231, 243)",
};
export const LIST_STYLE = {
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "row",
  p: 0,
};
export const PADDING_SM = { padding: "10px" };
export const MARGIN_TB = { marginTop: "2%", marginBottom: "2%",marginRight:"-17rem" };
export const COLOR_WHITE = { color: "white !important" };
export const NUMBER_FIELD_STYLE = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
};
export const MARGIN_TB_ITEMS_SM = { marginTop: "5px", marginBottom: "10px" };
export const RIGHT_ALIGN = { float: "right" };
export const HELPER_TEXT_STYLE = {
  fontSize: "14px",
  color: "red",
};
export const SUCCESS_TXT = {
  color: "green",
};
export const CENTER_ITEMS = {
  alignItems: "center",
  textAlign: "center",
  justifyContent: "center",
};
export const MARGIN_15 = { marginRight: "15px" };
export const MARGIN_R_10 = { marginRight: "10px" };
export const MARGIN_R_20 = { marginRight: "20px" };
export const ICON_STYLE = {
  stroke: PRIMARY_COLOR,
  height: "1em",
  width: "1em",
};
export const CLOSE_WINDOW_BTN = {
  alignItems: "center",
  textAlign: "center",
  justifyContent: "center",
  marginTop: "20px",
};
export const PADDING_3 = { p: 3 };
export const BACKGOUND_PRIMARY = { backgroundColor: PRIMARY_COLOR };
export const BACKGROUND_GRAY = { backgroundColor: "#CCD0E7" };
export const BACKGROUND_GRAY_HOVER = {
  "& button:hover": BACKGROUND_GRAY,
};
export const APPBAR_STYLES = {
  height: "60px",
  backgroundColor: `${PRIMARY_COLOR}`,
};
export const LOGIN_FAILIED_STYLE = {
  margin: "10%",
  marginLeft: "40%",
  fontSize: 32,
  fontWeight: 600,
};
export const HEADER_STYLE = {
  fontStyle: "italic",
  fontSize: "27pt",
  color: "#FFCC00 !important",
  fontWeight: "bold",
  padding: "0px",
  marginLeft: "1%",
};
export const MARGIN_P_0 = { p: 0, m: 0 };
export const WIDTH_100 = { width: "100%", p: 0, m: 0 };
export const HEADER_GRID_STYLE = {
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "flex-start",
  height: "100%",
};
export const HEIGHT_45 = {
  height: 45,
};
export const HEADER_GRID_LANG_STYLE = {
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "flex-end",
  height: "100%",
};
export const LANG_LABEL_STYLE = {
  color: "#FFCC00 !important",
  position: "relative",
  marginRight: "20px",
};
export const LANG_LIST_STYLE = {
  border: "1px solid black",
  position: "absolute",
  padding: "10px",
  width: "150px",
  top: 30,
  right: 0,
  zIndex: 10,
  color: "#FFCC00",
  backgroundColor: "#001489",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  cursor: "pointer",
};
export const GREETING_TXT_STYLE = {
  color: "#FFCC00",
  fontWeight: 600,
  marginRight: "20px",
};
export const POS_RELATIVE = { position: "relative" };
export const USER_ICON_STYLE = {
  height: 40,
  cursor: "pointer",
  marginRight: "-20px",
};
export const USER_ICON_LIST_STYLE = {
  border: "1px solid black",
  position: "absolute",
  padding: "10px",
  width: "120px",
  top: 50,
  right: -25,
  zIndex: 10,
  color: "#FFCC00",
  backgroundColor: "#001489",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  cursor: "pointer",
};
export const COMPITATOE_HEADER = {
  backgroundColor: "#424242",
  border: "solid 1px #525252",
};
export const COMPITATOE_ROW = {
  cursor: "pointer",
  border: "solid 1px #525252",
};
export const MIN_WIDTH_500 = { minWidth: 500 };
export const heightWidth16 = {
  height: "16px",
  width: "16px",
};
export const POS_AB_RT_8 = {
  position: "absolute",
  right: 8,
  top: 8,
};
export const MARGIN_PADD_02 = { m: 0, p: 2 };
export const LOADER_STYLE = {
  width: "25vw",
  height: "30vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
export const competitorTableRow = {
  cursor: "pointer",
  border: "solid 1px #525252",
};
export const minWidth500 = { minWidth: 500 };
export const MINWIDTH750 = { minWidth: 750 };
export const MAXHEIGHT420 = { maxHeight: "420px" };
export const MAXHEIGHT220 = { maxHeight: "220px" };
export const SELECTED_STYLE_RIGHT = { textAlign: "right", marginRight: "10px" };
export const SELECTED_STYLE = { flex: "1 1 100%", marginLeft: "7px" };
export const TABLE_CELL_STYLE = {
  maxWidth: "20px",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
export const HEIGHT10 = {
  height: "10px",
};
export const ENGINE_MAKEMODEL_WIDTH = { width: "20%", padding: "5px" };
export const PART_TABLE_WIDTH = { width: "22%", padding: "5px" };
export const PART_NUMBER_WIDTH = { width: "25%", padding: "5px" };
export const COMP_PART_WIDTH = { width: "10%", padding: "5px" };
export const WHITE = "white !important";

//LAbels
export const MAIN_HEADING = "NAPA Fleet Survey";
export const VEHICLE_TO_COPY = "Vehicles To Copy";
export const VEHICLE = "Vehicle";
export const PARTS = "Parts";
export const UNIT = "unit";
export const NO_RECORDS = "No records.";
export const APPEND_PARTS = "Append Part(s) To :";
export const WIN_STATUS = "VIN Status";
export const NOTE ='NOTE'
export const Name_Validation='Only letters, digits, space, underscore and hyphen are allowed'
export const PASTE_LABEL = "Paste";
export const CANCEL_LABEL = "Cancel";
export const CANCEL_IMPORT_LABEL = "Cancel Import";
export const CANCEL_SURVERY_LABEL = "Cancel Survey";
export const CONTINUE_IMPORT_LABEL = "Continue Import";
export const CONTINUE_SURVERY_LABEL = "Continue Survey";
export const DELETE_LABEL = "Delete";
export const DATE_FORMATE = "YYYY-MM-DD";
export const SURVEY_LABEL = "Survey";
export const IMPORT_LABEL = "Import";
export const LANG_ENG = "English";
export const LANG_FRENCH = "Canadien-français";
export const LANG_SPANISH = "español";
export const WELCOME_LABEL = "Welcome";
export const LOGOUT_LABEL = "Logout";
export const LOADING = "Loading...";
export const DISPLAY_LABEL = "display";
export const PRINT_LABEL = "print";
export const STOCK_LABEL = "stock";
export const EXCEL_LABEL = "excel";
export const FILTER_BY_LABEL = "Filter By";
export const EXPORT_SURVEY_LABEL = "Export Survey";
export const PRINT_SURVEY_LABEL = "Print Survey";
export const STOCK_LIST_LABEL = "Stock List";
export const SELECT_ALL_LABEL = "Select All";
export const SELECTED_LABEL = "selected";
export const COPY = "copy";
export const VEHICLE_LIST = "Vehicles List";
export const OK_LABEL = "OK";
export const OR_LABEL = "OR";
export const CLEAR_LABEL = "Clear";
export const CREATED_LABEL = "created";
export const REVISED_LABEL = "revised";
export const DATE_CREATED_FILTER_BY_LABEL = ">= Date Created";
export const DATE_REVISED_FILTER_BY_LABEL = ">= Date Revised";
export const INTERCHANGES_LABEL = "Interchanges";
export const PLEASE_WAIT_LABEL = "Please wait...";
export const FOOTER_TEXT_LABEL =
  "© Copyright 2024. National Automotive Parts Association. All Rights Reserved";
export const CLOSE_WINDOW_LABEL = "Close Window";
export const UPDATE = "update";
export const SAVE = "save";
export const VIN_FILTER_TEXT = "GKat Application with Napa filters";
export const NO_FlEET_SELECTION = "Fleet Not Selected";
export const NO_SURVEY_SELECTION = "Survey Not Selected";
export const LOADING_FAILED = "Failed to load data";
export const SELECT_SURVEY = "Please select survey";
export const SELECT_VEHICLE_TYPE = "Please select vehicle type";
export const IMPORT_SCREEN_WARNING_MSG =
  "**Please, be advised, Excel speadsheet should contain header columns only in the 1st row.";
export const IMPORT_VALIDATION_MSG = `Please select atleast "Make and Model" or Vin and any other field`;
export const IMPORT_FILE_ERROR_MSG = "**Please upload file below 5MB";

export const FILTER_DROPDOWN_DATA = [
  { id: 0, partType: "Air Filter" ,name: 'Air'},
  { id: 1, partType: "Fuel Filter", name: 'Fuel'},
  { id: 2, partType: "Oil Filter",name:'Oil' },
  { id: 3, partType: "Transmission Filter",name:'Transmission' },
  { id: 4, partType: "Hydraulic Filter" , name:'Hydraulic'},
  { id: 5, partType: "Cabin air Filter", name:'Cabin Air'},
  { id: 6, partType: "Coolant Filter" , name:'Coolant'},
  { id: 7, partType: "Breather Filter" ,name:'Breather'},
  { id: 8, partType: "DEF Filter" ,name:'DEF'},
  { id: 9, partType: "Power Steering", name:'Power Steering' },
];
export const POSITION_DROPDOWN_DATA = [
  { id: 0, position: "Primary" },
  { id: 1, position: "Secondary" },
  { id: 2, position: "Inner" },
  { id: 3, position: "Outer" },
  { id: 4, position: "By-Pass" },
];

export const PRINT_DROPDOWN_DATA = [
  { id: 0, name: "" },
  { id: 1, name: "Unit#" },
  { id: 2, name: "Make/Model" },
  { id: 3, name: "Sort By" },
];
 export  const vinRegex = /^[A-Za-z0-9]{9,17}$/;
export const PRINT_CHECK_DATA = [
  { id: 0, label: "Include Survey", checked: true, key: "includeSurvey" },
  {
    id: 3,
    label: "Include Filters by Unit",
    checked: false,
    key: "includeFiltersByUnit",
  },
  {
    id: 4,
    label: "Include Units by Filter",
    checked: false,
    key: "includeUnitsByFilter",
  },
];

// -- Part keys --//
export const PART_KEYS = {
  vehicleId: "",
  partType: "",
  quantity: 1,
  position: "",
  brand: "NAPA GOLD",
  partNumber: "",
  competitorPartNumber: "",
  competitorPartBrand: "",
  comments: "",
  subPartType: "",
};

//-- Vehicle form keys ---//
export const VEHICLE_KEYS = {
  id: "",
  name: "",
  vin: "",
  make: "",
  model: "",
  makeModel: "",
  engine: "",
  subModel: "",
  unitNo: "",
  sortBy: "",
  year: "",
  comments: "",
};

export const IMPORT_MAKE_MODEL_PROPS = {
  "data-testid": "select-dropdown",
  size: "small",
  labelId: "demo-select-big-label",
  testid: "select-data-for-mapping",
  id: "demo-select-big",
  className: "w-14-em",
  name: "makeModel",
};
export const IMPORT_MAKE_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "make",
};
export const IMPORT_MODEL_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "model",
};
export const IMPORT_SUB_MODEL_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};
export const IMPORT_ENGINE_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "engine",
};
export const IMPORT_MODEL_YEAR_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "year",
};
export const IMPORT_VIN_CODE_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "vin",
};
export const IMPORT_UNIT_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "unitNo",
};
export const IMPORT_COMMENTS_PROPS = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "comments",
};
// for pingID
export const COOKIE_KEY = "d_12";
export const DECRYPT_KEY = "d_11";
export const CODE_COOKIE = "code_verifier";
export const MORE_INFO_TEXT = " For more info about user On-boarding visit :";
export const AUTH_TEXT = "To authenticate, please enter your GPC Employee Number as your username and your GPC password. For additional security,authentication will be completed through PingID."
export const REDIRECT_URL = 'https://gpcprod.atlassian.net/wiki/spaces/COMPLATFORM/pages/1758298406/User+Onboarding+and+Access+Requirements';
export const CLICK_HERE_LABEL = "Click here";
export const SOMETHING_WENT_WRONG_API = "Something Went Wrong. Please try again later."
export const BAD_REQUEST = "Bad Request."
export const UNAUTHORISED = "Unauthorized."
export const NOT_FOUND = "API Not Found."
export const PLEASE_WAIT_MESSAGE = "Downloading... Please Wait";
export const SUPPRESSED_WARNINGS = [
  "validateDOMNesting(...): <div> cannot appear as a child of <tbody>"
];
export const FEEDBACK_BTN_STYLE = {
  marginTop: "40px",
  width: "100px",
  position: "fixed",
  zIndex: "1",
  right: "-80px",
  transform: "translateX(0%) translateY(-280%) rotate(90deg)",
  transformOrigin: "left",
  bottom: "45%",
};
export const MAIL_CLIENTS = [
  { client: "gmail", src: require("../assets/images/gmail1.png") ,testid:"gmail" },
  { client: "outlook", src: require("../assets/images/outlook-logo.png") , testid:"outlook" },
];
export const GMAIL = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=${process.env.REACT_APP_FEEDBACK_EMAIL}?subject=${encodeURIComponent(
  "Fleet%20Survey%20tool%20:%20Feedback"
)}`;
export const OUTLOOK = `https://outlook.office.com/mail/deeplink/compose?to=${process.env.REACT_APP_FEEDBACK_EMAIL}?subject=${encodeURIComponent(
  "Fleet%20Survey%20tool%20:%20Feedback"
)}`;

//style constants
export const ROW_FLEX = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};
export const MAIL_ASSET_STYLE = {
  height: "100px",
  width: "100px",
  cursor: "pointer",
  marginRight: "20px",
};

export const IMPORT_VEHICLE_TYPE = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};

export const IMPORT_MODEL_YEAR = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};
export const IMPORT_MAKE = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};
export const IMPORT_MODEL = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};
export const IMPORT_ENGINE = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};
export const IMPORT_SUBMODEL = {
  size: "small",
  labelId: "demo-select-big-label",
  id: "demo-select-big",
  className: "w-14-em",
  name: "subModel",
};

// export const VEHICLE_TYPE = "Vehicle Type";
// export const MODEL_YEAR = "Model Year";
// export const MAKE = "Make";
// export const MODEL = "Model";
// export const ENGINE = "Engine";
// export const SUB_MODEL = "Submodel";
// export const NO_ITEM_FOUND_TEXT = "No item found.";
// export const COLOR_FFF = { color: "#fff" };
